/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */

/**
 * Request body for recording a one-time T&C decision.
 */
export type TermsDecisionType = (typeof TermsDecisionType)[keyof typeof TermsDecisionType];

export const TermsDecisionType = {
  accept: 'accept',
  reject: 'reject',
} as const;
